import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getShopInfoAction } from 'states/actions/shop';
import { SHOPINFO_SYNC_KEY } from 'utils/shopInfoCrossTabSync';

export function useShopInfoCrossTabSync() {
  const dispatch = useDispatch();

  useEffect(() => {
    const refetch = () => {
      try {
        getShopInfoAction(dispatch)();
      } catch (e) {}
    };

    const onStorage = (e) => {
      if (e.key !== SHOPINFO_SYNC_KEY) return;
      refetch();
    };

    const onFocus = () => refetch();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refetch();
    };

    window.addEventListener('storage', onStorage);
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [dispatch]);
}